module.exports = __webpack_public_path__ + "img/memory1c.19796328.png";